module.exports = __webpack_public_path__ + "img/celular4.3ada0c4f.svg";